/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import Config from "../../../config/index";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  downloadStockAvailability,
  getDynamicColumn,
  getItemMaster,
  getStockAvailability,
  getSubModulesByRoleId,
} from "../../../store";

import { CSVLink } from "react-csv";

// Cookies
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import {
  Alert,
  Backdrop,
  CircularProgress,
  Collapse,
  IconButton,
  Modal,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import MDCard from "components/MDCard";

const desLength = Config.descriptionLength;

const cookies = new Cookies();

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const StockAvailability = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getStockAvailability,
  getStockAvailabilityReducer,
  downloadStockAvailability,
  downloadStockAvailabilityReducer,
  getItemMaster,

  itemMaster,
  getDynamicColumnReducer,

  createDynamicColumn,
  getDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let stockAvailableReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "151f9b48-0565-4eb0-a927-745a25b82018",
  );

  let viewAccess = stockAvailableReportModule
    ? stockAvailableReportModule.actionId.includes(
        "eee573c1-b528-40d8-acc2-66f2fada691e",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    if (globalFilter) {
      const cleanedFilter = Object.fromEntries(
        Object.entries(globalFilter).filter(([key, value]) => value !== ""),
      );
      setSearchObject(JSON.stringify(cleanedFilter));
    } else {
      setSearchObject("");
    }
  };

  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [relectedRmw, setRelectedRmw] = useState("");
  const [selectedsf, setSelectedsf] = useState("");

  useEffect(() => {
    downloadStockAvailability(
      pageNo,
      rowsPerPage,
      searchObject,
      relectedRmw ? relectedRmw.value : "",
      selectedsf ? selectedsf.value : "",
      jwtToken,
    );
  }, [pageNo, rowsPerPage, searchObject, relectedRmw, selectedsf, jwtToken]);
  const navigate = useNavigate();

  const [state, setState] = useState({
    columns: [
      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
        width: 320,
      },

      { Header: "Not Printed Grn ", accessor: "notPrintedGrnQty" },
      { Header: "Ramco qty", accessor: "ramcoQty" },
      { Header: "Rec Qty", accessor: "totalRecQty" },
      { Header: "Rmw qty", accessor: "totalRmwQty" },
      { Header: "sf qty", accessor: "totalSfQty" },
      { Header: "quarantine qty", accessor: "quarantineQty" },
      { Header: "rejection qty ", accessor: "rejectionQty" },
      { Header: "MR qty", accessor: "totalMrQty" },
      { Header: "booked qty", accessor: "bookedQty" },
      { Header: "consumed qty", accessor: "consumedQty" },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getStockAvailabilityReducer.stockAvailability.data
      ? getStockAvailabilityReducer.stockAvailability.data
      : [];
    setPaginationObj(getStockAvailabilityReducer.stockAvailability?.pagination);
    setLoading(getStockAvailabilityReducer.loading);
    data?.map((finishedGoods) => {
      let len = desLength;
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {finishedGoods?.itemDescription?.length > 35 ? (
              <Tooltip
                title={finishedGoods.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {finishedGoods.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {finishedGoods.itemDescription}
              </MDTypography>
            )}
            {finishedGoods?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        consumedQty: finishedGoods.consumedQty,
        bookedQty: finishedGoods.bookedQty,
        ramcoQty: finishedGoods.ramcoQty,
        totalRecQty: finishedGoods.totalRecQty,
        notPrintedGrnQty: finishedGoods.notPrintedGrnQty,

        totalRmwQty: finishedGoods.totalRmwQty,
        totalSfQty: finishedGoods.totalSfQty,
        quarantineQty: finishedGoods.quarantineQty,
        rejectionQty: finishedGoods.rejectionQty,
        totalMrQty: finishedGoods.totalMrQty,
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getStockAvailabilityReducer]);

  const rmwOptions = [{ label: "No Stock", value: "0" }];
  const sfOptions = [{ label: "No Stock", value: "0" }];

  useEffect(() => {
    getItemMaster(jwtToken);
  }, []);

  const handlesfChange = (selectedItemCode) => {
    setSelectedsf(selectedItemCode);
  };

  const handleRmwChange = (selectedItemCode) => {
    if (selectedItemCode) {
      setRelectedRmw(selectedItemCode);
    } else {
      setRelectedRmw(""); // Clear the value if it's not valid
    }
  };
  const [itemCodeOptions, setItemCodeOptions] = useState("");

  useEffect(() => {
    getStockAvailability(
      pageNo,
      rowsPerPage,
      searchObject,
      relectedRmw ? relectedRmw.value : "",
      selectedsf ? selectedsf.value : "",
      jwtToken,
    );
  }, [pageNo, rowsPerPage, searchObject, relectedRmw, selectedsf]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      // let des = item?.itemDescription;
      // let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode}`,
        value: item.itemCode,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [downloadData, setDownloadData] = useState("");

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = downloadStockAvailabilityReducer.stockAvailabilityReport.data
      ? downloadStockAvailabilityReducer.stockAvailabilityReport.data
      : [];

    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        itemDescription: finishedGoods.itemDescription,
        consumedQty: finishedGoods.consumedQty,
        bookedQty: finishedGoods.bookedQty,
        ramcoQty: finishedGoods.ramcoQty,
        totalRecQty: finishedGoods.totalRecQty,
        notPrintedGrnQty: finishedGoods.notPrintedGrnQty,
        totalRmwQty: finishedGoods.totalRmwQty,
        totalSfQty: finishedGoods.totalSfQty,
        quarantineQty: finishedGoods.quarantineQty,
        rejectionQty: finishedGoods.rejectionQty,
        totalMrQty: finishedGoods.totalMrQty,
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });

    setDownloadData(tempFinishedGoods);
  }, [downloadStockAvailabilityReducer]);

  const headers = [
    { label: "Item Code", key: "itemCode" },
    { label: "Item Description", key: "itemDescription" },
    { label: "Not Printed Grn ", key: "notPrintedGrnQty" },
    { label: "Ramco qty", key: "ramcoQty" },
    { label: "Rec Qty", key: "totalRecQty" },
    { label: "Rmw qty", key: "totalRmwQty" },
    { label: "SF qty", key: "totalSfQty" },
    { label: "quarantine qty", key: "quarantineQty" },
    { label: "rejection qty ", key: "rejectionQty" },
    { label: "MR qty", key: "totalMrQty" },
    { label: "bookedQty", key: "bookedQty" },
    { label: "consumned qty", key: "consumedQty" },
  ];
  const csvLink = {
    filename: "Stock Availability Report.csv",
    headers: headers,
    data: downloadData,
  };

  const subModuleId = "151f9b48-0565-4eb0-a927-745a25b82018";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  console.log("downloadData", downloadData);

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getStockAvailability(
        pageNo,
        rowsPerPage,
        searchObject,
        relectedRmw ? relectedRmw.value : "",
        selectedsf ? selectedsf.value : "",
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-2}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      alignItems="center"
                      width="100%"
                    >
                      <MDBox
                        width={{ xs: "100%", lg: "200px" }}
                        mb={{ xs: 2, lg: 0 }}
                        mr={{ lg: 2 }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          RMW Stock
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                          autoComplete="off"
                          value={relectedRmw}
                          options={rmwOptions}
                          onChange={handleRmwChange}
                        />
                      </MDBox>
                      <MDBox
                        width={{ xs: "100%", lg: "200px" }}
                        mb={{ xs: 2, lg: 0 }}
                        mr={{ lg: 2 }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          SF Stock
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                          autoComplete="off"
                          value={selectedsf}
                          options={sfOptions}
                          onChange={handlesfChange}
                        />
                      </MDBox>

                      <MDBox
                        style={{
                          marginTop: "25px",
                          marginLeft: { xs: 0, lg: "8px" },
                        }}
                      >
                        {downloadData?.length > 0 ? (
                          <CSVLink {...csvLink}>
                            <DownloadDataButton
                              type="button"
                              style={{ borderRadius: "5px" }}
                              size="small"
                              variant="outlined"
                              color="success"
                              iconOnly
                              tooltip="Download All Data"
                            >
                              <Icon>download</Icon>
                            </DownloadDataButton>
                          </CSVLink>
                        ) : (
                          <DownloadDataButton
                            disabled
                            type="button"
                            style={{ borderRadius: "5px" }}
                            size="small"
                            variant="outlined"
                            color="success"
                            iconOnly
                            tooltip="No data to download"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    // hideColumns={["", "asnCode", "vendorCodeName"]}
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getStockAvailabilityReducer: state.getStockAvailabilityReducer,

    itemMaster: state.itemMaster,
    downloadStockAvailabilityReducer: state.downloadStockAvailabilityReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),

    getStockAvailability: (
      pageNo,
      rowsPerPage,
      searchObject,
      relectedRmw,
      selectedsf,
      jwtToken,
    ) =>
      dispatch(
        getStockAvailability(
          pageNo,
          rowsPerPage,
          searchObject,
          relectedRmw,
          selectedsf,
          jwtToken,
        ),
      ),
    downloadStockAvailability: (
      pageNo,
      rowsPerPage,
      searchObject,
      relectedRmw,
      selectedsf,
      jwtToken,
    ) =>
      dispatch(
        downloadStockAvailability(
          pageNo,
          rowsPerPage,
          searchObject,
          relectedRmw,
          selectedsf,
          jwtToken,
        ),
      ),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(StockAvailability);
